/**
	* CLICKAR.BIZ INTERNATIONAL REST API
	* APIs Clickar.biz international.
	*
	* OpenAPI spec version: API V1
	* Contact: blureply@reply.com
	*
	* NOTE: This class is auto generated by the swagger code generator program.
	* https://github.com/swagger-api/swagger-codegen.git
	* Do not edit the class manually.
	*/
/* tslint:disable:no-unused-variable member-ordering */

import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable, Optional } from "@angular/core";

import { Observable } from "rxjs";

import { environment } from "@app/../environments/environment";
import { ChannelType, HeaderKey } from "@shared/clickar-constants";
import { UploadFileDTO } from "@shared/model/uploadFileDTO";
import {
	DossierUrlDTO,
	SendToMultiDTO,
	VVehicleAuction,
	VehicleDTO,
	VehicleDescDTO,
	VehicleDetailsDTO
} from "@shared/model/vehicle.model";
import { Configuration } from "@shared/services/utils/configuration";
import { CustomHttpUrlEncodingCodec } from "@shared/services/utils/encoder";


@Injectable()
export class VehicleService {
	private basePath = environment.baseApiUrl;
	private readonly k8sPath = environment.k8sApiUrl;

	defaultHeaders = new HttpHeaders();
	configuration = new Configuration();
	readonly encoderParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });

	constructor(
		protected httpClient: HttpClient,
		@Optional() configuration: Configuration
	) {
		if (configuration) {
			this.configuration = configuration;
			this.basePath ??= configuration.basePath;
		}
	}

	/**
	 * @param consumes string[] mime-types
	 * @return true: consumes contains "multipart/form-data", false: otherwise
	 */
	/* private canConsumeForm(consumes: string[]): boolean {
		const form = "multipart/form-data";
		for (const consume of consumes) {
			if (form === consume) {
				return true;
			}
		}
		return false;
	} */

	getDossierUrlUsingGET(licensePlate: string, vatCode: string, observe?: "body", reportProgress?: boolean): Observable<DossierUrlDTO> {
		let queryParameters = this.encoderParameters;

		if (licensePlate !== undefined && licensePlate !== null) {
			queryParameters = queryParameters.set("licensePlate", <any>licensePlate);
		}
		if (vatCode !== undefined && vatCode !== null) {
			queryParameters = queryParameters.set("vatCode", <any>vatCode);
		}

		return this.httpClient.get<DossierUrlDTO>(`${this.basePath}/api/v1/secure/dossier`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}

	getVehicleDescUsingGET(ids: number[], observe?: "body", reportProgress?: boolean): Observable<VehicleDescDTO[]> {
		let queryParameters = this.encoderParameters;

		if (ids) {
			for (const element of ids) {
				queryParameters = queryParameters.append("ids", <any>element);
			}
		}

		return this.httpClient.get<VehicleDescDTO[]>(`${this.basePath}/api/v1/secure/vehicle-desc`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}

	saveVehicleUsingPOSTv2(idTemp: number, observe?: "body", reportProgress?: boolean): Observable<VehicleDTO[]> {
		let queryParameters = this.encoderParameters;

		if (idTemp !== undefined && idTemp !== null) {
			queryParameters = queryParameters.set("idTemp", <any>idTemp);
		}

		let headers = this.defaultHeaders;

		// to determine the Accept header
		const httpHeaderAccepts = ["*/*"],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected)
				.set(HeaderKey.NO_SUCCESS_POPUP, "true");
		}

		// to determine the Content-Type header
		// const consumes = ["application/json"];

		return this.httpClient.post<VehicleDTO[]>(`${this.basePath}/api/v2/secure/save-vehicle`,
			null,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}

	getVehicleForAuctionUsingGET(idTemplate?: number, brand?: string, channel?: ChannelType, insertDate?: Date, insertDateTo?: Date, licensePlate?: string, maxAuctions?: number, maxDamage?: number, maxPrice?: number, minAuctions?: number, minDamage?: number, minPrice?: number, model?: string, provenance?: string, vehicleCode?: number, vehicleFrame?: string, provenances?: string[], observe?: "body", reportProgress?: boolean): Observable<VehicleDTO[]> {
		let queryParameters = this.encoderParameters;

		if (brand !== undefined && brand !== null) {
			queryParameters = queryParameters.set("brand", <any>brand);
		}
		if (channel !== undefined && channel !== null) {
			queryParameters = queryParameters.set("channel", <any>channel);
		}
		if (idTemplate !== undefined && idTemplate !== null) {
			queryParameters = queryParameters.set("idTemplate", <any>idTemplate);
		}
		if (insertDate !== undefined && insertDate !== null) {
			queryParameters = queryParameters.set("insertDate", <any>insertDate.toISOString());
		}
		if (insertDateTo !== undefined && insertDateTo !== null) {
			queryParameters = queryParameters.set("insertDateTo", <any>insertDateTo.toISOString());
		}
		if (licensePlate !== undefined && licensePlate !== null) {
			queryParameters = queryParameters.set("licensePlate", <any>licensePlate);
		}
		if (maxAuctions !== undefined && maxAuctions !== null) {
			queryParameters = queryParameters.set("maxAuctions", <any>maxAuctions);
		}
		if (maxDamage !== undefined && maxDamage !== null) {
			queryParameters = queryParameters.set("maxDamage", <any>maxDamage);
		}
		if (maxPrice !== undefined && maxPrice !== null) {
			queryParameters = queryParameters.set("maxPrice", <any>maxPrice);
		}
		if (minAuctions !== undefined && minAuctions !== null) {
			queryParameters = queryParameters.set("minAuctions", <any>minAuctions);
		}
		if (minDamage !== undefined && minDamage !== null) {
			queryParameters = queryParameters.set("minDamage", <any>minDamage);
		}
		if (minPrice !== undefined && minPrice !== null) {
			queryParameters = queryParameters.set("minPrice", <any>minPrice);
		}
		if (model !== undefined && model !== null) {
			queryParameters = queryParameters.set("model", <any>model);
		}
		if (provenance !== undefined && provenance !== null) {
			queryParameters = queryParameters.set("provenance", <any>provenance);
		}
		if (provenances) {
			for (const element of provenances) {
				queryParameters = queryParameters.append("provenances", <any>element);
			}
		}
		if (vehicleCode !== undefined && vehicleCode !== null) {
			queryParameters = queryParameters.set("vehicleCode", <any>vehicleCode);
		}
		if (vehicleFrame !== undefined && vehicleFrame !== null) {
			queryParameters = queryParameters.set("vehicleFrame", <any>vehicleFrame);
		}

		return this.httpClient.get<VehicleDTO[]>(`${this.k8sPath}/api/v1/secure/vehicle-for-auction`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}

	getVehicleInAuctionDetailUsingGET = (idVehicle: number, observe?: "body", reportProgress?: boolean): Observable<VVehicleAuction[]> => this.httpClient.get<VVehicleAuction[]>(`${this.basePath}/api/v1/secure/vehicle/${encodeURIComponent(String(idVehicle))}/auctions`,
		{
			withCredentials: this.configuration.withCredentials,
			headers: this.defaultHeaders,
			observe,
			reportProgress
		}
	);

	editVehicleUsingPUT = (vehicleDTO: VehicleDTO, observe?: "body", reportProgress?: boolean): Observable<any> => this.httpClient.put<any>(`${this.basePath}/api/v1/secure/vehicle`,
		vehicleDTO,
		{
			withCredentials: this.configuration.withCredentials,
			headers: this.defaultHeaders,
			observe,
			reportProgress
		}
	);

	getVehicleDetailsUsingGET = (idVehicle: number, observe?: "body", reportProgress?: boolean): Observable<VehicleDetailsDTO> => this.httpClient.get<VehicleDetailsDTO>(`${this.basePath}/api/v1/secure/vehicle/${encodeURIComponent(String(idVehicle))}/details`,
		{
			withCredentials: this.configuration.withCredentials,
			headers: this.defaultHeaders,
			observe,
			reportProgress
		}
	);

	sendToMultiAuctioneerUsingPATCH = (dto: SendToMultiDTO, observe?: "body", reportProgress?: boolean): Observable<any> => this.httpClient.patch<any>(`${this.basePath}/api/v1/secure/sendToMultiAuctioneer`,
		dto,
		{
			withCredentials: this.configuration.withCredentials,
			headers: this.defaultHeaders,
			observe,
			reportProgress
		}
	);

	getVehicle = (idVehicle: number, observe?: "body", reportProgress?: boolean): Observable<VehicleDTO> => this.httpClient.get<VehicleDTO>(`${this.basePath}/api/v1/secure/vehicle/${encodeURIComponent(String(idVehicle))}`,
		{
			withCredentials: this.configuration.withCredentials,
			headers: this.defaultHeaders,
			observe,
			reportProgress
		}
	);

	sendToSupUsingPATCH = (vehicleIds: number[], observe?: "body", reportProgress?: boolean): Observable<any> => this.httpClient.patch<any>(`${this.basePath}/api/v1/secure/sendToSup`,
		vehicleIds,
		{
			withCredentials: this.configuration.withCredentials,
			headers: this.defaultHeaders,
			observe,
			reportProgress
		}
	);

	getReferenceDealerUsingGET1 = (observe?: "body", reportProgress?: boolean): Observable<string[]> => this.httpClient.get<string[]>(`${this.basePath}/api/v1/secure/provenance`,
		{
			withCredentials: this.configuration.withCredentials,
			headers: this.defaultHeaders,
			observe,
			reportProgress
		}
	);

	uploadFileUsingPOST(provenance: string, file: Blob, observe?: "body", reportProgress?: boolean): Observable<UploadFileDTO>;
	uploadFileUsingPOST(provenance: string, file: Blob, observe: any = "body", reportProgress = false): Observable<UploadFileDTO> {
		if (file === null || file === undefined) {
			throw new Error("Required parameter file was null or undefined when calling uploadFileUsingPOST.");
		}

		let headers = this.defaultHeaders;

		// to determine the Accept header
		const httpHeaderAccepts = ["*/*"],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set(HeaderKey.NO_SUCCESS_POPUP, "true");
		}

		let formData = new FormData();

		formData.append("file", file);
		formData.append("provenance", provenance);

		return this.httpClient.post<any>(`${this.basePath}/api/v1/secure/upload-vehicle`,
			formData, {
			headers
		});
	}

	uploadAppraisalUsingPOST(file: Blob, tempId: string, tupla: string, observe?: "body", reportProgress?: boolean): Observable<any> {
		let headers = this.defaultHeaders;

		// to determine the Accept header
		const httpHeaderAccepts = ["*/*"],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		// const consumes = ["multipart/form-data"];
		let formData = new FormData();

		formData.append("file", file);
		if (tempId !== undefined && tempId !== null) {
			formData.append("tempId", tempId);
		}

		if (tupla !== undefined && tupla !== null) {
			formData.append("tupla", tupla);
		}

		return this.httpClient.post<any>(`${this.k8sPath}/api/v1/secure/upload-appraisal`,
			formData
		);
	}

	uploadDataSheetUsingPOST(file: Blob, tempId: string, tupla: string, observe?: "body", reportProgress?: boolean): Observable<any> {
		let queryParameters = this.encoderParameters;

		if (tempId !== undefined && tempId !== null) {
			queryParameters = queryParameters.set("tempId", <any>tempId);
		}
		if (tupla !== undefined && tupla !== null) {
			queryParameters = queryParameters.set("tupla", <any>tupla);
		}

		let headers = this.defaultHeaders;

		// to determine the Accept header
		const httpHeaderAccepts = ["*/*"],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		// const consumes = ["multipart/form-data"];

		let formData = new FormData();

		formData.append("file", file);
		if (tempId !== undefined && tempId !== null) {
			formData.append("tempId", tempId);
		}

		if (tupla !== undefined && tupla !== null) {
			formData.append("tupla", tupla);
		}
		return this.httpClient.post<any>(`${this.k8sPath}/api/v1/secure/upload-datasheet`, formData);
	}

	uploadOtherUsingPOST(file: Blob, tempId: string, tupla: string, observe?: "body", reportProgress?: boolean): Observable<any> {
		let queryParameters = this.encoderParameters;

		if (tempId !== undefined && tempId !== null) {
			queryParameters = queryParameters.set("tempId", <any>tempId);
		}
		if (tupla !== undefined && tupla !== null) {
			queryParameters = queryParameters.set("tupla", <any>tupla);
		}

		let headers = this.defaultHeaders;

		// to determine the Accept header
		const httpHeaderAccepts = ["*/*"],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		// const consumes = ["multipart/form-data"];
		let formData = new FormData();

		formData.append("file", file);
		if (tempId !== undefined && tempId !== null) {
			formData.append("tempId", tempId);
		}
		if (tupla !== undefined && tupla !== null) {
			formData.append("tupla", tupla);
		}
		return this.httpClient.post<any>(`${this.k8sPath}/api/v1/secure/upload-other`, formData);
	}

	uploadPhotosUsingPOST(file: Blob, tempId: string, tupla: string, observe?: "body", reportProgress?: boolean): Observable<any> {
		// let queryParameters = this.encoderParameters;

		let headers = this.defaultHeaders;

		// to determine the Accept header
		const httpHeaderAccepts = ["*/*"],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		// const consumes = ["multipart/form-data"];

		let formData = new FormData();

		formData.append("file", file);

		if (tempId !== undefined && tempId !== null) {
			formData.append("tempId", tempId);
		}

		if (tupla !== undefined && tupla !== null) {
			formData.append("tupla", tupla);
		}

		return this.httpClient.post<number>(`${this.k8sPath}/api/v1/secure/upload-photos`,
			formData
		);
	}

	uploadRecDocUsingPOST(file: Blob, tempId: string, tupla: string, observe?: "body", reportProgress?: boolean): Observable<any> {
		let queryParameters = this.encoderParameters;

		if (tempId !== undefined && tempId !== null) {
			queryParameters = queryParameters.set("tempId", <any>tempId);
		}
		if (tupla !== undefined && tupla !== null) {
			queryParameters = queryParameters.set("tupla", <any>tupla);
		}

		let headers = this.defaultHeaders;

		// to determine the Accept header
		const httpHeaderAccepts = ["*/*"],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		// const consumes = ["multipart/form-data"];

		let formData = new FormData();

		formData.append("file", file);
		if (tempId !== undefined && tempId !== null) {
			formData.append("tempId", tempId);
		}

		if (tupla !== undefined && tupla !== null) {
			formData.append("tupla", tupla);
		}

		return this.httpClient.post<any>(`${this.k8sPath}/api/v1/secure/upload-recdoc`,
			formData
		);
	}

	saveVehicleUsingPOST(idTemp: number, observe?: "body", reportProgress?: boolean): Observable<any> {
		let queryParameters = this.encoderParameters;

		if (idTemp !== undefined && idTemp !== null) {
			queryParameters = queryParameters.set("idTemp", <any>idTemp);
		}

		let headers = this.defaultHeaders;

		// to determine the Accept header
		const httpHeaderAccepts = ["*/*"],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected)
				.set(HeaderKey.NO_SUCCESS_POPUP, "true");
		}

		// to determine the Content-Type header
		// const consumes = ["application/json"];

		return this.httpClient.post<any>(`${this.basePath}/api/v1/secure/save-vehicle`,
			null,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}

	getProvenanceUsingGET(idMarket?: string, observe?: "body", reportProgress?: boolean): Observable<string[]> {
		let queryParameters = this.encoderParameters;

		if (idMarket !== undefined && idMarket !== null) {
			queryParameters = queryParameters.set("idMarket", <any>idMarket);
		}

		return this.httpClient.get<string[]>(`${this.basePath}/api/v1/secure/provenance`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}

	exportVehicleUsingPOST(vehicleIds: number[], observe?: "body", reportProgress?: boolean): Observable<any> {
		let headers = this.defaultHeaders;

		// to determine the Accept header
		const httpHeaderAccepts = ["*/*"],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", "text/csv; charset=utf-8");
		}

		const requestOptions: any = {
			/* other options here */
			withCredentials: this.configuration.withCredentials,
			headers,
			observe,
			reportProgress,
			responseType: "text"
		};

		return this.httpClient.post<any>(`${this.basePath}/api/v1/secure/export-vehicle`,
			vehicleIds,
			requestOptions
		);
	}

	getPdfUsingGET(idPdf: number, filename: string, observe?: "body", reportProgress?: boolean): Observable<string> {
		let queryParameters = this.encoderParameters;

		if (idPdf !== undefined && idPdf !== null) {
			queryParameters = queryParameters.set("idPdf", <any>idPdf);
		}
		if (filename !== undefined && filename !== null) {
			queryParameters = queryParameters.set("filename", <any>filename);
		}

		let headers = this.defaultHeaders.set("Accept", "application/pdf");

		const requestOptions: object = {
			/* other options here */
			params: queryParameters,
			withCredentials: this.configuration.withCredentials,
			headers,
			observe,
			reportProgress,
			responseType: "blob"
		};

		return this.httpClient.get<string>(`${this.basePath}/api/v1/secure/pdf`,
			requestOptions
		);
	}

	sendBackUsingPATCH(ids: number[], observe?: "body", reportProgress?: boolean): Observable<any> {
		return this.httpClient.patch<any>(`${this.basePath}/api/v1/secure/sendBack`,
			ids,
			{
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}

	getVehicleUsingGET(brand?: string, channel?: ChannelType, insertDate?: Date, insertDateTo?: Date, licensePlate?: string, maxAuctions?: number, maxDamage?: number, maxPrice?: number, minAuctions?: number, minDamage?: number, minPrice?: number, model?: string, provenance?: string, vehicleCode?: number, vehicleFrame?: string, observe?: "body", reportProgress?: boolean): Observable<any> {
		let queryParameters = this.encoderParameters;

		if (brand !== undefined && brand !== null) {
			queryParameters = queryParameters.set("brand", <any>brand);
		}
		if (channel !== undefined && channel !== null) {
			queryParameters = queryParameters.set("channel", <any>channel);
		}
		if (insertDate !== undefined && insertDate !== null) {
			queryParameters = queryParameters.set("insertDate", <any>insertDate);
		}
		if (insertDateTo !== undefined && insertDateTo !== null) {
			queryParameters = queryParameters.set("insertDateTo", <any>insertDateTo);
		}
		if (licensePlate !== undefined && licensePlate !== null) {
			queryParameters = queryParameters.set("licensePlate", <any>licensePlate);
		}
		if (maxAuctions !== undefined && maxAuctions !== null) {
			queryParameters = queryParameters.set("maxAuctions", <any>maxAuctions);
		}
		if (maxDamage !== undefined && maxDamage !== null) {
			queryParameters = queryParameters.set("maxDamage", <any>maxDamage);
		}
		if (maxPrice !== undefined && maxPrice !== null) {
			queryParameters = queryParameters.set("maxPrice", <any>maxPrice);
		}
		if (minAuctions !== undefined && minAuctions !== null) {
			queryParameters = queryParameters.set("minAuctions", <any>minAuctions);
		}
		if (minDamage !== undefined && minDamage !== null) {
			queryParameters = queryParameters.set("minDamage", <any>minDamage);
		}
		if (minPrice !== undefined && minPrice !== null) {
			queryParameters = queryParameters.set("minPrice", <any>minPrice);
		}
		if (model !== undefined && model !== null) {
			queryParameters = queryParameters.set("model", <any>model);
		}
		if (provenance !== undefined && provenance !== null) {
			queryParameters = queryParameters.set("provenance", <any>provenance);
		}
		if (vehicleCode !== undefined && vehicleCode !== null) {
			queryParameters = queryParameters.set("vehicleCode", <any>vehicleCode);
		}

		if (vehicleFrame !== undefined && vehicleFrame !== null) {
			queryParameters = queryParameters.set("vehicleFrame", <any>vehicleFrame);
		}

		return this.httpClient.get<any>(`${this.k8sPath}/api/v1/secure/vehicle`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}

	getVehicleByProvenancesUsingGET(brand?: string, channel?: ChannelType, insertDate?: Date, insertDateTo?: Date, licensePlate?: string, maxAuctions?: number, maxDamage?: number, maxPrice?: number, minAuctions?: number, minDamage?: number, minPrice?: number, model?: string, provenance?: string, provenances?: string[], vehicleCode?: number, vehicleFrame?: string, available?: boolean, observe?: "body", reportProgress?: boolean): Observable<VehicleDTO[]> {
		let queryParameters = this.encoderParameters;

		if (brand !== undefined && brand !== null) {
			queryParameters = queryParameters.set("brand", <any>brand);
		}
		if (channel !== undefined && channel !== null) {
			queryParameters = queryParameters.set("channel", <any>channel);
		}
		if (insertDate !== undefined && insertDate !== null) {
			queryParameters = queryParameters.set("insertDate", <any>insertDate.toISOString());
		}
		if (insertDateTo !== undefined && insertDateTo !== null) {
			queryParameters = queryParameters.set("insertDateTo", <any>insertDateTo.toISOString());
		}
		if (licensePlate !== undefined && licensePlate !== null) {
			queryParameters = queryParameters.set("licensePlate", <any>licensePlate);
		}
		if (maxAuctions !== undefined && maxAuctions !== null) {
			queryParameters = queryParameters.set("maxAuctions", <any>maxAuctions);
		}
		if (maxDamage !== undefined && maxDamage !== null) {
			queryParameters = queryParameters.set("maxDamage", <any>maxDamage);
		}
		if (maxPrice !== undefined && maxPrice !== null) {
			queryParameters = queryParameters.set("maxPrice", <any>maxPrice);
		}
		if (minAuctions !== undefined && minAuctions !== null) {
			queryParameters = queryParameters.set("minAuctions", <any>minAuctions);
		}
		if (minDamage !== undefined && minDamage !== null) {
			queryParameters = queryParameters.set("minDamage", <any>minDamage);
		}
		if (minPrice !== undefined && minPrice !== null) {
			queryParameters = queryParameters.set("minPrice", <any>minPrice);
		}
		if (model !== undefined && model !== null) {
			queryParameters = queryParameters.set("model", <any>model);
		}
		if (provenance !== undefined && provenance !== null) {
			queryParameters = queryParameters.set("provenance", <any>provenance);
		}
		if (provenances) {
			for (const element of provenances) {
				queryParameters = queryParameters.append("provenances", <any>element);
			}
		}
		if (vehicleCode !== undefined && vehicleCode !== null) {
			queryParameters = queryParameters.set("vehicleCode", <any>vehicleCode);
		}
		if (vehicleFrame !== undefined && vehicleFrame !== null) {
			queryParameters = queryParameters.set("vehicleFrame", <any>vehicleFrame);
		}

		return this.httpClient.get<VehicleDTO[]>(`${this.basePath}/api/v1/secure/vehicle-by-provenance`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders,
				observe,
				reportProgress
			}
		);
	}

	pubUnpubVehicle = (dto: { published: boolean; vehicleIds: number[] }) =>
		this.httpClient.put<any>(`${this.basePath}/api/v1/secure/vehicle/pubUnpubVehicle`,
			dto,
			{
				withCredentials: this.configuration.withCredentials,
				headers: this.defaultHeaders
			}
		);
}